import React, { useState } from "react";
import { Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { dateTimeSavedToDisplay } from "../../constants/vtrTrip";
import { tripStatusToDisplay } from "../../constants/TripStatus";

const TripSections = ({ type, trips, title, handleClick }) => {
  const [page, setPage] = useState(0);
  const [tripsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    event.preventDefault();
    setPage(newPage);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader arial-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell align="center" colSpan={5}>
                <Typography variant="h5" gutterBottom>
                  {title}
                </Typography>
              </TableCell>
              <TableCell />
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" width="10%">
                Trip
              </TableCell>
              <TableCell width="10%">Date Sailed</TableCell>
              <TableCell width="10%">Date Landed</TableCell>
              <TableCell width="15%">Vessel</TableCell>
              <TableCell width="5%">Effort(s)</TableCell>
              <TableCell width="10%">Status</TableCell>
              <TableCell width="5%">View Trip</TableCell>
              <TableCell width="5%">
                {type === "open" ? "Delete Trip" : "Hide Trip"}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {trips.length > 0 &&
              trips
                .sort((a, b) => b.date_sail.localeCompare(a.date_sail))
                .sort((a, b) => b.trip_id.localeCompare(a.trip_id))
                .slice(page * tripsPerPage, page * tripsPerPage + tripsPerPage)
                .map((trip, idx) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={idx}>
                      <TableCell component="th" scope="row" width="10%">
                        <Button
                          size="small"
                          onClick={handleClick("Row", trip.trip_id)}
                        >
                          {trip.submission_type.toUpperCase() === "PAPER"
                            ? trip.lowest_serial_num
                            : trip.trip_id}
                        </Button>
                      </TableCell>
                      <TableCell width="10%">
                        {trip.date_sail
                          ? dateTimeSavedToDisplay(trip.date_sail)
                          : "No date provided"}
                      </TableCell>
                      <TableCell width="10%">
                        {trip.date_land
                          ? dateTimeSavedToDisplay(trip.date_land)
                          : "No date provided"}
                      </TableCell>
                      <TableCell width="15%">
                        {`${trip.vessel_permit_num} ${trip.vessel_registration} ${trip.vessel_name}`}
                      </TableCell>
                      <TableCell width="5%">{trip.images.length}</TableCell>
                      <TableCell width="10%">
                        {tripStatusToDisplay(trip.trip_status)}
                      </TableCell>
                      <TableCell width="5%">
                        <Button
                          size="small"
                          startIcon={<EditIcon />}
                          onClick={handleClick("view", trip.trip_id)}
                        />
                      </TableCell>
                      <TableCell width="5%">
                        <Button
                          size="small"
                          startIcon={<DeleteIcon />}
                          onClick={
                            type === "open"
                              ? handleClick("delete", trip.trip_id)
                              : handleClick("hide", trip.trip_id)
                          }
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
          </TableBody>
        </Table>
        {trips.length === 0 && (
          <Typography
            sx={{
              typography: {
                fontFamily: "Proximanova Reg, sans-serif",
                button: {
                  textTransform: "none",
                  borderRadius: "5px",
                },
              },
            }}
          >
            No Trips Data.
          </Typography>
        )}
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[tripsPerPage]}
        component="div"
        count={trips.length}
        rowsPerPage={tripsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
    </>
  );
};

export default TripSections;
